export default __webpack_public_path__ + "static/media/managing_critical_position.360cf732.svg";